import { apiClient } from '../../../../../services/apiClient'
import type {
  BuildingNoteWithUser,
  CreateBuildingNoteDto,
} from '@popety-io/types'

export const buildingNotesService = {
  // Get notes for a specific building
  getBuildingNotes: async (
    buildingId: number | string
  ): Promise<BuildingNoteWithUser[]> => {
    try {
      const response = await apiClient.get(
        `/notes/building/by-building/${buildingId}`
      )
      // The API returns an array of notes directly
      return response.data || []
    } catch (error) {
      console.error('Get building notes error:', error)
      throw error
    }
  },

  // Create a new note for a building
  createBuildingNote: async (
    buildingId: string,
    data: CreateBuildingNoteDto
  ): Promise<BuildingNoteWithUser> => {
    try {
      const response = await apiClient.post(
        `/notes/building/by-building/${buildingId}`,
        data
      )
      return response.data
    } catch (error) {
      console.error('Create building note error:', error)
      throw error
    }
  },

  // Update an existing note
  updateBuildingNote: async (
    noteId: number,
    data: CreateBuildingNoteDto
  ): Promise<BuildingNoteWithUser> => {
    try {
      const response = await apiClient.put(`/notes/building/${noteId}`, data)
      return response.data
    } catch (error) {
      console.error('Update building note error:', error)
      throw error
    }
  },

  // Delete a note
  deleteBuildingNote: async (noteId: number): Promise<void> => {
    try {
      await apiClient.delete(`/notes/building/${noteId}`)
    } catch (error) {
      console.error('Delete building note error:', error)
      throw error
    }
  },
}
